import { render, staticRenderFns } from "./ProgressTabInstallationPartnerButtonEmail.vue?vue&type=template&id=8c64e79a&"
import script from "./ProgressTabInstallationPartnerButtonEmail.vue?vue&type=script&lang=ts&"
export * from "./ProgressTabInstallationPartnerButtonEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports